// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__2hDM_"};